(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, saxone-header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('saxone-pagination-recovery')) {
    class SaxonePaginationRecovery extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || window.Shopify?.designMode) return;
          const target = new URL(window.location.href);
          const pageParam = this.dataset.pageParam;
          if (!pageParam || !target.searchParams.has(pageParam)) return;
          const requestedPage = Number(target.searchParams.get(pageParam));
          if (!Number.isInteger(requestedPage) || requestedPage <= 1 || requestedPage !== Number(this.dataset.currentPage)) return;
          target.searchParams.delete(pageParam);
          const link = this.querySelector('a');
          if (link) link.href = target.href;
          window.location.replace(target.href);
        });
      }
    }
    customElements.define('saxone-pagination-recovery', SaxonePaginationRecovery);
  }

  if (!customElements.get('saxone-collection-controls')) {
    class SaxoneCollectionControls extends HTMLElement {
      connectedCallback() {
        this.syncLabels = () => {
          const summary = this.querySelector('.mobile-facets__disclosure > .mobile-facets__open-wrapper');
          if (summary) {
            summary.setAttribute('role', 'button');
            summary.setAttribute('tabindex', '0');
          }
          this.querySelectorAll('.mobile-facets__open-label').forEach(label => {
            if (label.textContent !== this.dataset.moreFilters) label.textContent = this.dataset.moreFilters;
          });
          if (this.pendingSortFocus && !this.pendingSortFocus.isConnected) {
            if (document.activeElement === document.body) this.querySelector('#SortBy')?.focus();
            this.pendingSortFocus = null;
          }
        };
        this.onSortInput = event => {
          if (event.target.id !== 'SortBy' || !event.target.closest('#FacetSortDrawerForm')) return;
          const mobileSort = this.querySelector('#SortBy-mobile');
          if (!mobileSort) return;
          this.pendingSortFocus = document.activeElement === event.target ? event.target : null;
          event.stopImmediatePropagation();
          mobileSort.value = event.target.value;
          mobileSort.dispatchEvent(new Event('input', { bubbles: true }));
        };
        this.addEventListener('input', this.onSortInput, true);
        this.observer = new MutationObserver(this.syncLabels);
        this.observer.observe(this, { subtree: true, childList: true });
        this.syncLabels();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onSortInput, true);
        this.observer?.disconnect();
      }
    }
    customElements.define('saxone-collection-controls', SaxoneCollectionControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saxone-curated-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saxone-product-tabs')) {
    class SaxoneProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-tabs-ready')) return;
        this.tabs = [...this.querySelectorAll('[data-saxone-tab]')];
        this.panels = [...this.querySelectorAll('[data-saxone-panel]')];
        const tablist = this.querySelector('[data-saxone-tablist]');
        if (!tablist || this.tabs.length !== this.panels.length || !this.tabs.length) return;

        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            let nextIndex = index;
            const isRtl = getComputedStyle(tablist).direction === 'rtl';
            if (event.key === 'ArrowRight') nextIndex += isRtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') nextIndex += isRtl ? 1 : -1;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = this.tabs.length - 1;
            else return;
            event.preventDefault();
            nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
            this.selectTab(nextIndex);
            this.tabs[nextIndex].focus();
          });
        });
        this.selectTab(0);
        this.setAttribute('data-tabs-ready', '');
        tablist.hidden = false;
      }

      selectTab(activeIndex) {
        this.tabs.forEach((tab, index) => {
          const active = index === activeIndex;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[index].hidden = !active;
        });
      }
    }
    customElements.define('saxone-product-tabs', SaxoneProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saxone-restock-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('saxone-restock-popup')) {
customElements.define('saxone-restock-popup', class extends HTMLElement {
connectedCallback() {
if (this.initialized) return;
this.initialized = true;
this.dialog = this.querySelector('dialog');
this.frame = this.querySelector('iframe');
this.storageKey = 'saxone-newsletter-dismissed-until';
this.viewsKey = 'saxone-newsletter-pageviews';
this.controller = new AbortController();
const signal = this.controller.signal;
this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), { signal }));
this.dialog.addEventListener('close', () => {
document.documentElement.style.overflow = this.previousOverflow || '';
this.remember(this.submitted ? 365 : 14);
}, { signal });
this.dialog.addEventListener('click', event => {
if (event.target !== this.dialog) return;
const rect = this.dialog.getBoundingClientRect();
if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
}, { signal });
document.addEventListener('click', event => {
const link = event.target.closest('a');
if (!link || link.hasAttribute('data-full-form') || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
const url = new URL(link.href, location.href);
if (url.origin !== location.origin || url.pathname !== this.dataset.newsletterUrl || this.blocked()) return;
event.preventDefault();
this.open();
}, { signal });
window.addEventListener('message', event => {
if (event.source !== this.frame.contentWindow || event.origin !== location.origin || !event.data || event.data.source !== 'saxone-newsletter-form') return;
if (event.data.type === 'resize' && Number.isFinite(event.data.height)) this.frame.style.height = Math.max(260, Math.min(1600, event.data.height)) + 'px';
if (event.data.type === 'success' || event.data.type === 'complete') {
if (this.submitted) return;
this.submitted = true;
this.remember(365);
if (this.dataset.thankYouUrl) {
const target = new URL(this.dataset.thankYouUrl, location.origin);
if (target.origin === location.origin) location.assign(target.href);
}
}
if (event.data.type === 'close' && this.dialog.open) this.dialog.close();
}, { signal });
document.addEventListener('shopify:section:select', event => {
if (this.hasAttribute('data-design-mode') && event.target.contains(this)) this.open();
}, { signal });
if (this.hasAttribute('data-design-mode')) return;
const requested = location.hash === '#newsletter';
if (requested) { this.attempts = 0; this.openTimer = setTimeout(() => this.tryOpen(), 600); return; }
// Chi arriva da una email/newsletter Brevo: niente pop-up, e segnato come visto per 30 giorni.
const params = new URLSearchParams(location.search);
const source = (params.get('utm_source') || '').toLowerCase();
const medium = (params.get('utm_medium') || '').toLowerCase();
if (source === 'brevo' || source === 'sendinblue' || medium === 'email' || params.has('_bta_tid')) { this.remember(30); return; }
let dismissed = false;
try { dismissed = Number(localStorage.getItem(this.storageKey)) > Date.now(); } catch (error) { dismissed = false; }
if (dismissed) return;
this.attempts = 0;
if (window.matchMedia('(max-width: 749px)').matches) {
// Telefono: alla seconda pagina vista.
let views = 1;
try { views = (Number(localStorage.getItem(this.viewsKey)) || 0) + 1; localStorage.setItem(this.viewsKey, String(views)); } catch (error) { views = 1; }
if (views >= 2) this.openTimer = setTimeout(() => this.tryOpen(), 4000);
return;
}
// Computer: dopo 20 secondi o a metà pagina, quello che arriva prima.
this.openTimer = setTimeout(() => this.tryOpen(), 20000);
const onScroll = () => {
const max = document.documentElement.scrollHeight - window.innerHeight;
if (max > 0 && window.scrollY / max >= 0.5) {
window.removeEventListener('scroll', onScroll);
clearTimeout(this.openTimer);
this.tryOpen();
}
};
window.addEventListener('scroll', onScroll, { passive: true, signal });
}
remember(days) {
try {
const previous = Number(localStorage.getItem(this.storageKey)) || 0;
localStorage.setItem(this.storageKey, String(Math.max(previous, Date.now() + days * 86400000)));
} catch (error) { return; }
}
blocked() {
if (document.hidden) return true;
return [...document.querySelectorAll('#iubenda-cs-banner, .shopify-pc__banner__dialog, #shopify-pc__banner, dialog[open], .drawer.active, .menu-drawer-container[open]')].some(node => node !== this.dialog && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden');
}
tryOpen() {
if (!this.isConnected || this.dialog.open || this.autoDone) return;
const editing = document.activeElement && document.activeElement.matches('input, textarea, select, [contenteditable="true"]');
if (!this.blocked() && !editing) { this.open(); return; }
this.attempts += 1;
if (this.attempts < 90) this.openTimer = setTimeout(() => this.tryOpen(), 2000);
}
open() {
if (this.dialog.open || this.blocked() || typeof this.dialog.showModal !== 'function') return;
clearTimeout(this.openTimer);
if (!this.frame.hasAttribute('srcdoc')) {
const content = this.querySelector('[data-form-document]').innerHTML;
const language = this.dataset.lang === 'it' ? 'it' : 'en';
this.frame.srcdoc = '<!doctype html><html lang="' + language + '"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><base href="' + location.origin + '/"></head><body>' + content + '</body></html>';
}
this.previousOverflow = document.documentElement.style.overflow;
this.dialog.showModal(); this.autoDone = true;
document.documentElement.style.overflow = 'hidden';
this.remember(14);
}
disconnectedCallback() {
clearTimeout(this.openTimer);
if (this.dialog.open) {
document.documentElement.style.overflow = this.previousOverflow || '';
this.dialog.close();
}
this.controller.abort();
this.initialized = false;
}
});
}

  } catch(e) { console.error(e); }
})();
})();
